import React from 'react'
import styled from 'styled-components'

export const Footer = (): JSX.Element => {
  return <Container id='footer' />
}

export default Footer

const Container = styled.div`
  height: ${({ theme }) => theme.dimensions.footerHeight};
  margin-top: ${({ theme }) => theme.dimensions.footerHeight};
  flex: none;
  width: 100%;
`
